import { z } from "zod";
import stringSchema from "@/lib/utils/stringSchema";

const formSchema = z.object({
  qa_assigneee_id: stringSchema({ key: "Assignee", required: true }),
  qa_comment_for_assignee: stringSchema({ key: "Comment", required: true }),
  files: z.array(z.any()),
})

export default formSchema;